import BaseService from './BaseService'
import { getHeader } from '../util/axios_helper'
// getAxiosInterceptor

// import firebase from 'firebase/compat/app'
// import { getJWT } from '../util/jwt_helper'

class PerformanceMonitoringService extends BaseService {
  sendBeaconRequest = false
  frontendTokenLogSent = false
  constructor(baseUrl: string) {
    super(baseUrl)

    this.sendBeaconRequest = baseUrl.includes('/_pm')
  }

  private sendBeacon(url: string, data: any) {
    if (!navigator.sendBeacon) {
      console.warn('[Perf] SendBeacon not supported in this browser');
      return false;
    }

    try {
      const payload = JSON.stringify({
        data,
        headers: getHeader()
      });

      // Check payload size (64KB = 65536 bytes)
      if (payload.length > 65536) {
        console.warn('[Perf] Payload too large for sendBeacon:', payload.length, 'bytes');
        return false;
      }

      const blob = new Blob([payload], {
        type: 'text/plain;charset=UTF-8'
      });
      return navigator.sendBeacon(url, blob);
    } catch (error) {
      console.error('[Perf] Failed to send beacon:', error);
      return false;
    }
  }

  monitoringPerformance = (body: any) => {
    if (this.sendBeaconRequest) {
      this.sendBeacon(`${this.baseUrl}/1/route-change-logs`, body) //new index
      return
    }
    this.requests.post(`/1/route-change-logs`, body).catch(error  => {
      console.error('[Perf] Failed to send route change logs request:', error);
    })
  }

  logFirestorePerformance = async (body: any) => {
    if (this.sendBeaconRequest) {
      this.sendBeacon(`${this.baseUrl}/1/firestore-logs`, body)
      return
    }
    this.requests.post(`/1/firestore-logs`, body).catch(error  => {
      console.error('[Perf] Failed to send firestore logs request:', error);
    })
  }

  logFrontendTokenLogs = async (body: any) => {
    if (this.frontendTokenLogSent) {
      return
    }
    this.frontendTokenLogSent = true
    if (this.sendBeaconRequest) {
      this.sendBeacon(`${this.baseUrl}/1/frontend-token-logs`, body)
      return
    }
    this.requests.post(`/1/frontend-token-logs`, body).catch(error  => {
      console.error('[Perf] Failed to send frontend logout request:', error);
    })
    setTimeout(() => {
      this.frontendTokenLogSent = false
    }, 60 * 60 * 1000) // 1 hour
  }
}

const instance = new PerformanceMonitoringService(BaseService.servicesConfig.PerformanceMonitoringService as string)

export default instance
